module.exports = __webpack_public_path__ + "assets/img/sig.ba6ad3b8.png";